import React, { useState } from 'react'
import styled from 'styled-components'
import Footer from './components/Footer'
import Header from './components/Header'
import MainContext from './context'

// COMPONENT
export default function MainTemplate({ children }: Props) {
    const [category, setCategory] = useState<string>()

    return (
        <MainContext.Provider value={{ category, setCategory }}>
            <Wrapper>
                <Header />
                <div>{children}</div>
                <Footer />
            </Wrapper>
        </MainContext.Provider>
    )
}

// TYPES
interface Props {
    children: React.ReactNode
}

// STYLES
const Wrapper = styled.div`
    min-height: 100vh;
    display: grid;
    grid-template-rows: auto 1fr auto;
    grid-template-columns: minmax(0, 1fr);
`